import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class EntryGroupService {

  url: string = 'entry_groups';

  constructor(private httpClient: HttpClientService) {}

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params)
  }

  searchOptions(params: any = {}): Promise<any> {
    params.search_options = true;
    return this.httpClient.get(`${this.url}.json`, params);
  }
}
